import { addDoc, collection, deleteDoc, doc, onSnapshot, query, setDoc } from 'shared/services/firebase';
import { updateProperties, writeDefaultTemplate } from 'shared/services/template-properties';
import { v4 } from 'uuid';
import { computed, ref } from 'vue';

export default function useTemplate(db, user, subscriptionManager) {
  const templates = ref({});
  let workspace = {};
  const loading = ref(true);

  const init = (newWorkspace) => {
    loading.value = true;
    workspace = newWorkspace;
    const q = query(collection(db, 'users', user.value.uid, 'workspaces', workspace.id, 'templates'));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      templates.value = {};
      querySnapshot.forEach((doc) => {
        const data = doc.data();
        if (data.database.archived === false) {
          templates.value[doc.id] = {
            id: doc.id,
            name: data.name,
            database: data.database,
            properties: updateProperties(data.properties, data.database),
            blocks: data.blocks === undefined ? [] : data.blocks,
          };
        }
      });
    });
    subscriptionManager.addSubscriber(unsubscribe, { auth: true });
    loading.value = false;
  };

  const getAll = () => computed(() => Object.values(templates.value));

  const getSingle = (id) => {
    if (tmpTemplate.value.id === id) {
      return tmpTemplate.value;
    }

    return templates.value[id];
  };

  const deleteSingle = async (id) => {
    const docRef = doc(db, 'users', user.value.uid, 'workspaces', workspace.id, 'templates', id);
    await deleteDoc(docRef);
  };

  const tmpTemplate = ref({});
  const addTmpTemplate = (data) => {
    const id = v4();
    tmpTemplate.value = { id, ...data };
    return id;
  };

  const addSingle = async (data) => {
    const colRef = collection(db, 'users', user.value.uid, 'workspaces', workspace.id, 'templates');
    const subdocRef = await addDoc(colRef, data);
    return subdocRef.id;
  };

  const updateSingle = (id, data) => {
    const docRef = doc(db, 'users', user.value.uid, 'workspaces', workspace.id, 'templates', id);
    setDoc(docRef, data);
  };
  const selectedTemplateId = ref(null);
  const selectTemplate = (id) => {
    selectedTemplateId.value = id;
  };

  const selectedTemplate = computed(() => getSingle(selectedTemplateId.value));

  return {
    init,
    getAll,
    getSingle,
    deleteSingle,
    addSingle,
    tmpTemplate,
    addTmpTemplate,
    updateSingle,
    selectTemplate,
    writeDefaultTemplate,
    selectedTemplate,
    loading,
  };
}
